import { atom } from 'recoil';
import type { OPCAttribute, OPCChangeType, OPCIdentifier } from '../types/opcTypes';
import { type ProductName_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';

export const opcInfoAtom = atom<OPCIdentifier>({
    key: 'change',
    default: ((): OPCIdentifier => {
        const searchParams = new URLSearchParams(window.location.search);
        const getParamValue = (param: string): string => searchParams.get(param) ?? '';
        return {
            policeNummer: getParamValue('policeNummer'),
            tilpas: getParamValue('tilpas') as OPCChangeType,
            productName: getParamValue('productName') as ProductName_Top,
            coverableId: getParamValue('coverableId'),
            coverageId: getParamValue('coverageId'),
            attribute: getParamValue('attribute') as OPCAttribute,
            attributeValue: getParamValue('attributeValue'),
            isFromDAFlow: false
        };
    })()
});
